<template>
  <b-card style="padding:40px;">
    <h5><b>PURCHASE ORDER (PREVIEW)</b></h5>
    <hr />
    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-name`">Full Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-date`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-date`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-companyName`">Company Name</label>
          <b-form-input
            v-model="form.company"
            :id="`input-companyName`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-roles`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-roles`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <TablePurchaseOrderPreview :fields="fields" :items="items" />
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickSubmit">
          SUBMIT
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import TablePurchaseOrderPreview from "@/table/user/purchaseOrder/TablePurchaseOrderPreview";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import Failed from "@/pages/Notifications/Failed";
import moment from "moment";

export default {
  data() {
    return {
      category: "",
      id: "",
      pro_cat: "",
      items: [
        {
          name: "",
          sku: "",
          qty: "",
          product_id: ""
        }
      ],
      form: {
        id: "",
        category: "",
        name: "",
        role: "",
        company: "",
        date: "",
        type: ""
      },

      temp_data: "",

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "qtyType",
          sortable: true
        }
      ]
    };
  },
  created() {
    let temp = localStorage.getItem("data_po");

    let data = JSON.parse(temp);
    localStorage.removeItem("data_po");

    this.temp_data = data;

    this.items = data.items;
    this.id = data.id;
    this.category = data.category;
    this.form.date = data.date ? moment(data.date).format("DD/MM/YYYY") : "";

    this.form.type = parseInt(data.pro_cat) === 1 ? "UHT" : "Pasteurized";

    this.getUser();
  },
  methods: {
    showPO() {
      this.$store.dispatch("showPO", this.id).then(res => {
        if (res.data.response.code === 100) {
          this.form.id = res.data.data.purchase_id;
          this.form.name = res.data.data.userdetails.name;
          this.form.date = moment(res.data.data.date).format("DD/MM/YYYY");
          this.form.company = res.data.data.userdetails.company;
          this.form.role = res.data.data.userdetails.role_details.desc;
          res.data.data.pro_stock.forEach(element => {
            this.items.push({
              name: element.product.name,
              sku: element.product_id,
              quantity: element.quantity,
              quantity_type: element.quantity_type === 1 ? "Pcs" : "Ctn"
            });
          });
        }
      });
    },
    onClickBack() {
      localStorage.setItem("data_po", JSON.stringify(this.temp_data));

      this.$router.push({
        path: `createPO?id=${this.id}&cat=2&type=update&from=update`
      });
    },
    onClickSubmit() {
      this.$store
        .dispatch("updateStatusMF", {
          category: 2,
          id: this.id
        })
        .then(res => {
          if (res.data.response.code === 1) {
            localStorage.removeItem("data_po");
            this.$notify({
              component: NotificationTemplate,
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
            this.$router.push({
              path: `viewPOUser?id=${this.id}&cat=2&from=created`
            });
          } else {
            this.$notify({
              component: Failed,
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          }
        });
    },

    getUser() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$store.getters.getUser_id
        })
        .then(res => {
          if (res.data.response && res.data.response.code === 100) {
            this.form.name = res.data.data.name;
            this.form.company = res.data.data.company;
            this.form.role = res.data.data.role_details.desc;
          }
        });
    }
  },
  components: {
    TablePurchaseOrderPreview
  }
};
</script>
<style lang="css" scoped></style>
